import React, { Component } from 'react';

import RouteEntry from './components/RouteEntry/index.js';

import './index.css';
class PortletRoutesWidget extends Component {
  constructor() {
    super();

    this.renderMessage = this.renderMessage.bind(this);
    this.renderRouteTable = this.renderRouteTable.bind(this);
    this.renderRouteEntries = this.renderRouteEntries.bind(this);
  }

  render() {

    return (
      <div className={this.props.error ? 'portlet_routes_widget error' : 'portlet_routes_widget'}>

        <div className="title">

          <div className="text">
            Specify portlet routes
          </div>

          <div className="control" onClick={this.props.addRouteHandler}>
            + New Route
          </div>

        </div>

        {this.props.data && this.props.data.length > 0 ? this.renderRouteTable() : this.renderMessage()}

      </div>
    );
  }

  renderMessage() {
    return (
      <div className="message">
        Routes specify how requests to your portlet endpoints are to be handled
      </div>
    );
  }

  renderRouteTable() {
    return (
      <div className="table_area">

        <table className="proper_table">

          <thead>
            <tr>
              <td className="align_left">ID</td>
              <td className="align_left">Route</td>
              <td className="align_left">URL</td>
              <td className="align_left">Strip Prefix</td>
              <td></td>
            </tr>
          </thead>

          <tbody>
            {this.renderRouteEntries(this.props.data)}
          </tbody>

        </table>

      </div>
    );
  }

  renderRouteEntries(routesList) {
    let renderContent = routesList.map((item, index) => {
      return (
        <RouteEntry
          index={index} {...item}
          updateRouteHandler={this.props.updateRouteHandler}
          deleteRouteHandler={this.props.deleteRouteHandler}
        />
      );
    });

    return renderContent;
  }



}

export default PortletRoutesWidget;





// WEBPACK FOOTER //
// ./src/routes/components/PorletRoutesWidget/index.js